var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{class:['zg-loader', {
      [`zg-loader--color-${_vm.color}`]: _vm.color,
      'zg-loader--boxed': _vm.boxed && _vm.fullscreen,
      'zg-loader--fullscreen': _vm.fullscreen,
      'zg-loader--button': _vm.button
    }]},[_c('div',{class:[
        'zg-loader__box',
        `zg-loader--${_vm.size}`
      ]},[(_vm.text)?_c('p',{staticClass:"zg-loader__text"},[_vm._v("\n        "+_vm._s(_vm.text)+"\n      ")]):_vm._e(),_vm._v(" "),_c('svg',{staticClass:"zg-loader__circles",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"25 25 50 50"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":_vm.button ? 21 : 23,"fill":"none","stroke-miterlimit":"10"}}),_vm._v(" "),_c('circle',{staticClass:"circle-animation",attrs:{"cx":"50","cy":"50","r":_vm.button ? 21 : 23,"fill":"none","stroke-miterlimit":"10"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }